import defineComponent from 'flight';

function CollapsedParagraph() {
    this.defaultAttrs({
        textSelector: '[data-category-intro-text]',
        buttonSelector: '[data-hider-button]'
    });

    this._showText = function () {
        this.$node.addClass('expanded');
    };

    this._updateUi = function () {
        let $text = this.select('textSelector')[0];
        if ($text.scrollHeight > $text.clientHeight) {
            this.select('buttonSelector').removeClass('hidden');
        } else {
            this._showText();
        }
    };

    this.after('initialize', function () {
        this.on(
            'click',
            {
                buttonSelector: this._showText
            });
        this._updateUi();
    });
}

module.exports = defineComponent.component(CollapsedParagraph);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/collapsed-paragraph.js